import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import OnPageEditing from 'components/OnPageEditing';

import css from './Block.module.scss';

import { THEMES, getThemeClassNames } from 'constants/themes';

const defaultOptions = {
    heading: true,
    headingComponent: "h2"
};

export default function Block(WrappedComponent, providedOptions) {
    const options = Object.assign(defaultOptions, providedOptions);
    return class HOCBlock extends React.Component {
        static propTypes = {
            heading: PropTypes.string,
            theme: PropTypes.oneOf(Object.keys(THEMES).map(s => THEMES[s])),
        }

        static defaultProps = {
            theme: THEMES.zebra
        }

        render() {
            const heading = options.heading && this.props.heading;
            const theme = this.props.theme;

            return (
                <div 
                    className={cn(css.block, getThemeClassNames(css, theme))}
                >
                    {[
                        heading && (
                            <OnPageEditing key="heading" property="Heading">
                                {React.createElement(
                                    options.headingComponent,
                                    { className: css.heading },
                                    heading
                                )}
                            </OnPageEditing>
                        ),
                        <WrappedComponent
                            key="Component"
                            {...this.props}
                        />
                    ]}
                </div>
            );
        }
    };
}



// WEBPACK FOOTER //
// ./src/hoc/Block/Block.jsx